import { MoveType } from "@chesshotel/types";
import { cn } from "../lib/utils";
import { FaStar } from "react-icons/fa";
import { FaThumbsUp } from "react-icons/fa";
import { FaBookOpen } from "react-icons/fa";
import { FaCheck } from "react-icons/fa";
import { FaXmark } from "react-icons/fa6";
import { useSettings } from "@/redux/settings";

const iconStyle =
  "w-6 h-6 rounded-full flex items-center justify-center leading-none text-white text-sm font-bold";

export const moveTypeStyles = {
  [MoveType.BLUNDER]: {
    bgColor: "bg-red-600",
    textColor: "text-red-600",
    content: "??",
  },
  [MoveType.MISS]: {
    bgColor: "bg-red-500",
    textColor: "text-orange-400",
    content: <FaXmark size={18} />,
  },
  [MoveType.MISTAKE]: {
    bgColor: "bg-orange-300",
    textColor: "text-orange-300",
    content: "?",
  },
  [MoveType.INACCURACY]: {
    bgColor: "bg-yellow-400",
    textColor: "text-yellow-400",
    content: "?!",
  },
  [MoveType.BOOK]: {
    bgColor: "bg-[#634a1a]",
    textColor: "text-[#634a1a]",
    content: <FaBookOpen />,
  },
  [MoveType.GOOD]: {
    bgColor: "bg-green-600",
    textColor: "text-green-600",
    content: <FaCheck />,
  },
  [MoveType.EXCELLENT]: {
    bgColor: "bg-green-500",
    textColor: "text-green-500",
    content: <FaThumbsUp />,
  },
  [MoveType.BEST]: {
    bgColor: "bg-green-400",
    textColor: "text-green-400",
    content: <FaStar />,
  },
  [MoveType.GREAT]: {
    bgColor: "bg-great",
    textColor: "text-great",
    content: "!",
  },
  [MoveType.BRILLIANT]: {
    bgColor: "bg-brilliant",
    textColor: "text-brilliant",
    content: "!!",
  },
};

const sizeStyles = {
  base: "w-6 h-6",
  small: "w-5 h-5 text-xs font-bold",
  large: "w-8 h-8 text-lg",
};

// const fontSizeStyles = {
//   base: "text-sm",
//   small: "text-xs",
//   large: "text-lg",
// };

export function moveTypeBgColor(move: MoveType) {
  return moveTypeStyles[move]?.bgColor || "";
}

export function moveTypeTextColor(move: MoveType) {
  return moveTypeStyles[move]?.textColor || "";
}

export default function MoveIcon({
  className = null,
  moveType,
  size = "base",
  scaleWithSquare = false,
  addShadow = false,
}) {
  if (!moveType || !moveTypeStyles[moveType]) return null;

  const { boardSize } = useSettings();

  const { bgColor, content } = moveTypeStyles[moveType];
  const sizeStyle = scaleWithSquare ? "w-[38%] h-[38%]" : sizeStyles[size];

  const squareSize = (boardSize / 8) * 0.2;

  const fontSizeStyle = scaleWithSquare ? { fontSize: squareSize + "px" } : {};
  const shadowStyle = addShadow ? "drop-shadow" : "";

  return (
    <div
      style={fontSizeStyle}
      className={cn(iconStyle, bgColor, sizeStyle, shadowStyle, className)}
    >
      {content}
    </div>
  );
}
